/* tourist/spending */
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'
import _ from 'lodash'
import { calculatePercentBetweenYear, calculateShortPrice, calculateNormalPercent } from "Helpers/helpers";

const state = {
    spending_beginDate: null,
    spending_lastDate: null,
    spending_datasets: [],
    spending_income_tourism: [],
    spending_income_tourism_table: [],
    spending_revenue_region_table: [],
    spending_revenue_region: [],
    spending_proportion_income: [],
    spending_average_income: [],
    spending_average_income_table: [],
    spending_average_income_table_averages:[],
    spending_average_income_table_type: null,
    spending_visit_state: [],
    //v2
    spending_isLoading: false,
    spending_year: {},
    year_x_location_destination: {},
    year_x_location_destination_region: {},
    year_x_spending_city_type: {},
    n_year_x_spending_travel_type: {}
}

// getters
const getters = {
    spending_year: state => {
        return state.spending_year;
    },
    spending_isLoading: state => {
        return state.spending_isLoading;
    },
    spending_data_date: state => {
        if (state.spending_beginDate !== null) {
            var _start = state.spending_beginDate.split("T");
            var _end = state.spending_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        } else {
            return "N/A"
        }
    },
    spending_datasets: state => {
        return state.spending_datasets;
    },
    spending_income_tourism: state => {
        return state.spending_income_tourism;
    },
    spending_income_tourism_table: state => {
        return state.spending_income_tourism_table;
    },
    spending_revenue_region_table: state => {
        return state.spending_revenue_region_table;
    },
    spending_revenue_region: state => {
        return state.spending_revenue_region;
    },
    spending_proportion_income: state => {
        return state.spending_proportion_income;
    },
    spending_average_income: state => {
        return state.spending_average_income;
    },
    spending_average_income_table: state => {
        return state.spending_average_income_table;
    },
    spending_visit_state: state => {
        return state.spending_visit_state;
    },
    spending_average_income_table_averages: state => {
        return state.spending_average_income_table_averages;
    },
    spending_average_income_table_type: state => {
        return state.spending_average_income_table_type;
    }
}

// actions
const actions = {
    // start /v2 actions
    V2getSpendingDatasets(context, payload) {
        state.spending_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
            if (main_filters.year != null) {
                _params.year = main_filters.year;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        instance.get('v2/tourist/spending', request)
            .then(response => {
                const { rows } = response.data;

                const {
                    year,
                    year_x_location_destination,
                    year_x_location_destination_region,
                    year_x_spending_city_type,
                    n_year_x_spending_travel_type,
                } = response.data;

                state.spending_year = year;
                state.spending_beginDate = moment(new Date(year.selected + "-01-01")).format("YYYY-MM-DD");
                if (year.selected == moment().format("YYYY")) {
                    state.spending_lastDate = moment().format("YYYY-MM-DD");
                } else {
                    state.spending_lastDate = moment(new Date(year.selected + "-12-31")).format("YYYY-MM-DD");
                }

                state.year_x_location_destination = year_x_location_destination;
                state.year_x_location_destination_region = year_x_location_destination_region;
                state.year_x_spending_city_type = year_x_spending_city_type;
                state.n_year_x_spending_travel_type = n_year_x_spending_travel_type;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "spending_income_tourism") {
                        context.commit("V2onSpendingIncomeTourism", payload);
                    } else if (stateName == "spending_revenue_region") {
                        context.commit("V2onSpendingRevenueRegion", payload);
                    } else if (stateName == "spending_proportion_income") {
                        context.commit("V2onSpendingProportionIncome", payload);
                    } else if (stateName == "spending_average_income") {
                        context.commit("V2onSpendingAverageIncome", payload);
                    } else if (stateName == "spending_visit_state") {
                        context.commit("V2onSpendingVisitState", payload);
                    }
                })
                state.spending_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/tourist/spending] syntax errors under instant.get");
            })
    },
    getSpendingDomDatasets(context, payload) {
        state.spending_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
            if (main_filters.year != null) {
                _params.year = main_filters.year;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        instance.get('tourist/spending_dom', request)
            .then(response => {
                const { rows } = response.data;

                let {
                    year
                } = response.data;

                state.spending_year = year;
                state.spending_beginDate = moment(new Date(year.selected + "-01-01")).format("YYYY-MM-DD");
                if (year.selected == moment().format("YYYY")) {
                    state.spending_lastDate = moment().format("YYYY-MM-DD");
                } else {
                    state.spending_lastDate = moment(new Date(year.selected + "-12-31")).format("YYYY-MM-DD");
                }

                state.year_x_location_destination = response.data;
                state.year_x_location_destination_region = response.data;
                // state.year_x_spending_city_type = year_x_spending_city_type;
                state.n_year_x_spending_travel_type = response.data;
                
                //context.commit("V2onSpendingIncomeTourism", payload);

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "spending_income_tourism") {
                        // widget no 23
                        context.commit("onSpendingIncomeTourism", payload);
                    } else if (stateName == 'spending_revenue_region') {
                        // widget no 24
                        context.commit("onSpendingRevenueRegion", payload);
                    }
                })

                state.spending_isLoading = false;
            }).catch(error => {
                console.log(error.response, "[store/tourist/spending_dom] syntax errors under instant.get");
            })
    },
    getSpendingIntDatasets(context, payload) {
        state.spending_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_source != null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_source_international != null) {
                _params.location_source = main_filters.location_source_international;
            }
            if (main_filters.year != null) {
                _params.year = main_filters.year;
            }
            if (main_filters.visit_type != null) {
                _params.visit_type = main_filters.visit_type;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        instance.get('tourist/spending_int', request)
            .then(response => {
            const { rows } = response.data;

            let {
                year
            } = response.data;

            state.spending_year = year;
            state.spending_beginDate = moment(new Date(year.selected + "-01-01")).format("YYYY-MM-DD");
            if (year.selected == moment().format("YYYY")) {
                state.spending_lastDate = moment().format("YYYY-MM-DD");
            } else {
                state.spending_lastDate = moment(new Date(year.selected + "-12-31")).format("YYYY-MM-DD");
            }

            state.year_x_location_destination = response.data;
            state.year_x_location_destination_region = response.data;
            state.n_year_x_spending_travel_type = response.data;
            state.spending_average_income_table_averages = response.data;

            payload.stateDatasets.forEach(function(stateName) {
               if (stateName == 'spending_average_income') {
                // widget no 27
                context.commit('onSpendingAverageIncome', payload)
               }
            })

            state.spending_isLoading = false;
        }).catch(error => {
            console.log(error.response, "[store/tourist/spending_int] syntax errors under instant.get");
        })
    },
    getSpendingIntChartDatasets(context, payload) {
        state.spending_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_source_international != null) {
                _params.location_source = main_filters.location_source_international;
            }
            if (main_filters.year != null) {
                _params.year = main_filters.year;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        instance.get('tourist/spending_int/chart', request)
            .then(response => {
            const { rows } = response.data;

            payload.standard_chart_info = response.data;

            payload.stateDatasets.forEach(function(stateName) {
               if (stateName == 'spending_average_income') {
                // widget no 27
                context.commit('onSpendingAverageIncome', payload)
               }
            })

            state.spending_isLoading = false;
        }).catch(error => {
            console.log(error.response, "[store/tourist/spending_int] syntax errors under instant.get");
        })
    },
    getSpendingIntByTypeDatasets(context, payload) {
        state.spending_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_source != null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.year != null) {
                _params.year = main_filters.year;
            }
            if (main_filters.location_source_international != null) {
                _params.location_source = main_filters.location_source_international;
            }
            if (main_filters.visit_type != null) {
                _params.visit_type = main_filters.visit_type;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        instance.get('tourist/spending_int_by_type', request)
            .then(response => {
            const { rows } = response.data;

            let {
                year
            } = response.data;

            state.spending_year = year;
            state.spending_beginDate = moment(new Date(year.selected + "-01-01")).format("YYYY-MM-DD");
            if (year.selected == moment().format("YYYY")) {
                state.spending_lastDate = moment().format("YYYY-MM-DD");
            } else {
                state.spending_lastDate = moment(new Date(year.selected + "-12-31")).format("YYYY-MM-DD");
            }

            state.year_x_location_destination = response.data;
            state.year_x_location_destination_region = response.data;
            state.n_year_x_spending_travel_type = response.data;

            payload.stateDatasets.forEach(function(stateName) {
               if (stateName == 'spending_average_income') {
                // widget no 27
                context.commit('onSpendingAverageIncome', payload)
               }
            })

            state.spending_isLoading = false;
        }).catch(error => {
            console.log(error.response, "[store/tourist/spending_int_by_type] syntax errors under instant.get");
        })
    },
    getSpendingDatasets(context, payload) {
        console.log("[store/tourist/spending] getSpendingDatasets() DEPRECATED");
        return;
    }
}

// mutations
const mutations = {
    // start /v2 mutations
    onSpendingIncomeTourism(state, payload) {
        // --- start dataset for jvector map
        // items = [{label1:0,label2:0,...,data:0,label:'',location_destination:'',percentage:'',filter_voc_sentiment:null},...]
        var rows = state.year_x_location_destination.rows;
        var items = [];

        let total_thai_revenue = 0;
        let total_foreigner_revenue = 0;
        rows.forEach(function(item, index) {
            total_thai_revenue += item.thai.sum_revenue;
            total_foreigner_revenue += item.foreigner.sum_revenue;

            var pos = items.map(function(e) {
                return e.location_destination;
            }).indexOf(item._id.location_destination);

            if (pos == -1) {
                let item_obj = {
                    label: item._id.location_destination,
                    location_destination: item._id.location_destination,
                    data: {
                        thai_revenue: item.thai.sum_revenue,
                        foreigner_revenue: item.foreigner.sum_revenue
                    }
                }
                items.push(item_obj);
            } else {
                items[pos].data.thai_revenue += item.thai.sum_revenue;
                items[pos].data.foreigner_revenue += item.foreigner.sum_revenue;
            }
        });

        // Convert new format
        items.forEach(function(item, index) {
            let percentage_thai = ((item.data.thai_revenue / total_thai_revenue) * 100);
            let percentage_foreigner = ((item.data.foreigner_revenue / total_foreigner_revenue) * 100);
            let percentage = {
                thai: percentage_thai,
                foreigner: percentage_foreigner
            }
            items[index].percentage = percentage;
            items[index].location_destination = items[index].label;
            items[index].label = items[index].label.toUpperCase() + " " + numeral(percentage).format('0,0.00') + "% (" + numeral(item.data).format('0,0') + ")";
        });
        state.spending_income_tourism = items
        // --- end dataset for jvector map
        state.spending_income_tourism_table = rows;
    },
    onSpendingRevenueRegion(state, payload) {
        // --- start dataset for doughnut chart
        // items = [{data:number,label:string,color:string}]
        var rows = state.year_x_location_destination_region.rows;
        let current_year = state.year_x_location_destination_region.year.selected

        // console.log(rows);
        // return false;

        // map new format array
        const result_datas = rows.map((item) => {
            
            let result = {
                region: item.region,
                year: item.year,
                province: item.province,
                location_type: item.location_type,
                thai_revenue: item.thai.sum_revenue,
                foreigner_revenue: item.foreigner.sum_revenue
            }

            // process check if prev year exists for assign
            if (typeof item.prevYear !=='undefined' && Object.keys(item.prevYear).length > 0) {
                let prevInfo = {
                    year: item.prevYear.year,
                    thai_revenue: item.prevYear.thai.sum_revenue,
                    foreigner_revenue: item.prevYear.foreigner.sum_revenue
                }
                Object.assign(result, { prevYear: prevInfo })
            }
            // end process check if prev year exists for assign
            
            // process check if begin year exists for assign
            if (typeof item.beginYear !=='undefined' && Object.keys(item.beginYear).length > 0) {
                let beginInfo = {
                    year: item.beginYear.year,
                    thai_revenue: item.beginYear.thai.sum_revenue,
                    foreigner_revenue: item.beginYear.foreigner.sum_revenue
                }
                Object.assign(result, { beginYear: beginInfo })
            }
            // end process check if begin year exists for assign

            return result;
        })

        let region_alls = [
            'ภาคเหนือ',
            'ภาคกลาง',
            'ภาคตะวันออกเฉียงเหนือ',
            'ภาคตะวันออก',
            'ภาคใต้'
        ]

        let regions = [];
        let prev_year = parseInt(current_year) - 1
        let begin_year = parseInt(current_year) - 2

        let current_datas = result_datas.filter((resp) => resp)

        let prev_datas = result_datas.filter((resp) => typeof resp.prevYear !=='undefined' && parseInt(resp.prevYear.year) == prev_year).map((resp) => {
            return {
                location_type: resp.location_type,
                region: resp.region,
                ...resp.prevYear
            }
        }).filter((resp) => resp);

        let bigin_datas = result_datas.filter((resp) => typeof resp.beginYear !=='undefined' && parseInt(resp.beginYear.year) == begin_year).map((resp) => {
            return {
                location_type: resp.location_type,
                region: resp.region,
                ...resp.beginYear
            }
        }).filter((resp) => resp);


        // assign variable sum all
        let sum_all_main_city = 0;
        let sum_all_second_city = 0;

        let prev_sum_all_main_city = 0;
        let prev_sum_all_second_city = 0;

        let begin_sum_all_main_city = 0;
        let begin_sum_all_second_city = 0;

        let total_current_sum = 0;
        let total_prev_sum = 0;
        let total_begin_sum = 0;

        // loop all regions
        region_alls.forEach((region) => {
            
            // current year data
            let main_city_of_region = current_datas.filter((resp) => resp.location_type == 'เมืองหลัก' && resp.region == region).map((resp) => parseFloat(resp.thai_revenue) + parseFloat(resp.foreigner_revenue)).reduce((a, b) => a + b, 0)
            let second_city_of_region = current_datas.filter((resp) => resp.location_type == 'เมืองรอง' && resp.region == region).map((resp) => parseFloat(resp.thai_revenue) + parseFloat(resp.foreigner_revenue)).reduce((a, b) => a + b, 0)

            sum_all_main_city += main_city_of_region;
            sum_all_second_city += second_city_of_region;
            // end current year data

            // previos year data
            let prev_main_city_of_region = prev_datas.filter((resp) => resp.location_type == 'เมืองหลัก' && resp.region == region).map((resp) => parseFloat(resp.thai_revenue) + parseFloat(resp.foreigner_revenue)).reduce((a, b) => a + b, 0)
            let prev_second_city_of_region = prev_datas.filter((resp) => resp.location_type == 'เมืองรอง' && resp.region == region).map((resp) => parseFloat(resp.thai_revenue) + parseFloat(resp.foreigner_revenue)).reduce((a, b) => a + b, 0)

            prev_sum_all_main_city += prev_main_city_of_region;
            prev_sum_all_second_city += prev_second_city_of_region;
            // end previos year data

            // begin year data
            let begin_main_city_of_region = bigin_datas.filter((resp) => resp.location_type == 'เมืองหลัก' && resp.region == region).map((resp) => parseFloat(resp.thai_revenue) + parseFloat(resp.foreigner_revenue)).reduce((a, b) => a + b, 0) || 0
            let begin_second_city_of_region = bigin_datas.filter((resp) => resp.location_type == 'เมืองรอง' && resp.region == region).map((resp) => parseFloat(resp.thai_revenue) + parseFloat(resp.foreigner_revenue)).reduce((a, b) => a + b, 0) || 0

            begin_sum_all_main_city += begin_main_city_of_region;
            begin_sum_all_second_city += begin_second_city_of_region;
            // end begin year data

            total_current_sum = parseFloat(sum_all_main_city) + parseFloat(sum_all_second_city)
            total_prev_sum = parseFloat(prev_sum_all_main_city) + parseFloat(prev_sum_all_second_city)
            total_begin_sum = parseFloat(begin_sum_all_main_city) + parseFloat(begin_sum_all_second_city)

            let json_data = {
                region: region,
                revenue: {
                    city: {
                        main: main_city_of_region,
                        percent_main: calculatePercentBetweenYear(main_city_of_region, prev_main_city_of_region),
                        second: second_city_of_region,
                        percent_second: calculatePercentBetweenYear(second_city_of_region, prev_second_city_of_region)
                    },
                    sum: main_city_of_region + second_city_of_region
                },
                prevData: {
                    year: prev_year,
                    revenue: {
                        city: {
                            main: prev_main_city_of_region,
                            percent_main: calculatePercentBetweenYear(prev_main_city_of_region, begin_main_city_of_region),
                            second: prev_second_city_of_region,
                            percent_second: calculatePercentBetweenYear(prev_second_city_of_region, begin_second_city_of_region)
                        },
                        sum: prev_main_city_of_region + prev_second_city_of_region
                    }
                },
                beginData: {
                    year: begin_year,
                    revenue: {
                        city: {
                            main: begin_main_city_of_region,
                            second: begin_second_city_of_region
                        },
                        sum: begin_main_city_of_region + begin_second_city_of_region
                    }
                }
            }
            regions.push(json_data);
        })

        // process for calculate percent sum
        regions.map((item) => {
            let total_current_sum = item.revenue.sum || 0
            let total_prev_sum = item.prevData.revenue.sum || 0
            let total_begin_sum = item.beginData.revenue.sum || 0

            item.revenue.percent_sum = calculatePercentBetweenYear(total_current_sum, total_prev_sum);
            item.prevData.revenue.percent_sum = calculatePercentBetweenYear(total_prev_sum, total_begin_sum);
            
            return item;
        })


        let results = {
            years: [current_year, prev_year],
            rows: [...regions],
            totals: {
                main: sum_all_main_city,
                second: sum_all_second_city,
                all: total_current_sum,
                prevData: {
                    main: prev_sum_all_main_city,
                    second: prev_sum_all_second_city,
                    all: total_prev_sum
                },
                beginData: {
                    main: begin_sum_all_main_city,
                    second: begin_sum_all_second_city,
                    all: total_begin_sum
                }
            }
        }
        // process set format output to table

        state.spending_revenue_region_table = results;
        // end process set format output to table

        let colors = [];
        colors['เมืองหลัก'] = '#3241a6';
        colors['เมืองรอง'] = '#578e47';
        
        let items = [];
        let total = 0;

        items = results.rows.map((item) => {
            return {
                year: `${item.region}`,
                // 'ชาวไทย': item.revenue.nationality.thai,
                // 'ชาวต่างชาติ': item.revenue.nationality.foreigner,
                'เมืองหลัก': item.revenue.city.main,
                'เมืองรอง': item.revenue.city.second
            }
        })

        // attached colors 
        items.push(colors);

        state.spending_revenue_region = items
        // --- end dataset for doughnut chart
    },
    V2onSpendingProportionIncome(state, payload) {
        // --- start dataset for doughnut chart
        // items = [{data:number,label:string,color:string}]
        var rows = state.year_x_spending_city_type.rows;
        var items = [];
        var total = 0;
        rows.forEach(function(item, index) {
            total += item.sum_spending_travel_receipts;
            var _item = { data: item.sum_spending_travel_receipts, label: item._id.spending_city_type };
            if (item._id.spending_city_type == "เมืองหลัก") {
                items[0] = _item;
            } else if (item._id.spending_city_type == "เมืองรอง") {
                items[1] = _item;
            } else {
                items.push(_item);
            }
        });
        if (total == 0) {
            items = [];
        }
        state.spending_proportion_income = items
        // --- end dataset for doughnut chart
    },
    V2onSpendingVisitState(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,year:string}] 
        var colors = [];
        colors['นักท่องเที่ยว'] = '#3241a6';
        colors['ผู้เยี่ยมเยือน'] = '#578e47';
        colors['นักทัศนาจร'] = '#cf9a41';

        var rows = state.n_year_x_spending_travel_type.rows;
        var items = [];
        var total = 0;
        rows.forEach(function(item, index) {
            total += item.sum_spending_travel_receipts;
            var _item = {};
            var pos = items.map(function(e) {
                return e.year;
            }).indexOf(item._id.year);
            if (pos == -1) {
                _item['year'] = item._id.year;
                _item['นักท่องเที่ยว'] = 0;
                _item['ผู้เยี่ยมเยือน'] = 0;
                _item['นักทัศนาจร'] = 0;
                _item[item._id.spending_travel_type] = item.sum_spending_travel_receipts;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[item._id.spending_travel_type] === undefined) {
                    _item[item._id.spending_travel_type] = item.sum_spending_travel_receipts;
                } else {
                    _item[item._id.spending_travel_type] += item.sum_spending_travel_receipts;
                }
                items[pos] = _item;
            }
        });

        // sort by date year        
        items.sort(function(a, b) {
            var _a = parseInt(a.year);
            var _b = parseInt(b.year);
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.spending_visit_state = items;
        // --- end dataset for stack chart
    },
    async onSpendingAverageIncome(state, payload) {

        // use for widget no 27
        let datas = state.n_year_x_spending_travel_type;
        let datas_averages = state.spending_average_income_table_averages;
        let countries = datas.countries || [];
        let spending_types = datas.spending_types || [];
        let years = [];

        let amount_type ='incomes';
        let year_selected = parseInt(datas.year.selected);

        let visit_type_selected = null;
        if (payload.main_filters != null) {
            if (payload.main_filters.amount_type != null) {
                amount_type = payload.main_filters.amount_type;
            }
            if (payload.main_filters.year != null) {
                year_selected = parseInt(payload.main_filters.year);
            }
            if (payload.main_filters.visit_type != null) {
                visit_type_selected = payload.main_filters.visit_type;
            }
        }

        // process set data format to Stackbar chart
        let result_charts = [];

        if (visit_type_selected =='seven_type_summary') {
            let rows = datas.rows || []
            years = [...new Set(rows.map((resp) => resp.year))].sort((a, b) => a - b);

            let totals_income = 0;
            let totals_average = 0;

            years.forEach((year) => {
                let types = [];
                let all_type = {};
                let row_types =[];

                if (spending_types.length > 0) {
                    spending_types.forEach((spending_type) => {
                    
                        totals_income = datas.rows.filter((resp) => resp.year == year && resp.spending_type == spending_type).map((resp) => resp.incomes).reduce((a, b) => a + b, 0);
                        totals_average = datas.rows.filter((resp) => resp.year == year && resp.spending_type == spending_type).map((resp) => resp.averages).reduce((a, b) => a + b, 0);
                        
                        all_type = {
                            year: year,
                            spending_type: spending_type,
                            totals_income: totals_income,
                            totals_average: totals_average
                        }
    
                        types.push(all_type);
                    });
                }

                row_types = types.filter((resp) => resp.year == year).map((item) => {
                    return {
                        spending_type: item.spending_type,
                        incomes: item.totals_income,
                        averages: item.totals_average
                    }
                });

                let years_all = {
                    year: year,
                    types: row_types
                }
                result_charts.push(years_all);
            })

            let items_chart = [];

            result_charts.forEach((item, index) => {
    
                let type = {};
                item.types.forEach((info) => {
                    type[info.spending_type] = info[amount_type]
                })
    
                let result = {
                    year: item.year,
                    ...type
                }
                items_chart.push(result);
            })
    
            let colors = [];
            colors['Accommodation'] = '#ab8ec3';
            colors['Entertainment'] = '#fb8b00';
            colors['Food & Beverage'] = '#6697c3';
            colors['Local Transport'] = '#ffd00d';
            colors['Miscellaneous'] = '#ff96c5';
            colors['Shopping'] = '#54b948';
            colors['Sightseeing'] = '#dbd6a9';
    
            // // attached colors 
            items_chart.push(colors);
            // end process set data format to Stackbar chart
    
            state.spending_average_income = items_chart;
            // --- end dataset for stack chart
        } else {
            // display standard chart from spending_ints
            let chart_info = payload.standard_chart_info || {};
            
            let visit_types = chart_info.visit_types || [];
            let rows = chart_info.rows || []
            years = [...new Set(rows.map((resp) => resp.year))].sort((a, b) => a - b);

            let totals_income = 0;
            let totals_average = 0;

            years.forEach((year) => {
                let types = [];
                let all_type = {};
                let row_types =[];

                if (visit_types.length > 0) {
                    visit_types.forEach((visit_type) => {
                    
                        totals_income = chart_info.rows.filter((resp) => resp.year == year && resp.visit_type == visit_type).map((resp) => resp.incomes).reduce((a, b) => a + b, 0);
                        totals_average = chart_info.rows.filter((resp) => resp.year == year && resp.visit_type == visit_type).map((resp) => resp.averages).reduce((a, b) => a + b, 0);
                        
                        all_type = {
                            year: year,
                            visit_type: visit_type,
                            totals_income: totals_income,
                            totals_average: totals_average
                        }
    
                        types.push(all_type);
                    });
                }

                row_types = types.filter((resp) => resp.year == year).map((item) => {
                    return {
                        visit_type: item.visit_type,
                        incomes: item.totals_income,
                        averages: item.totals_average
                    }
                });

                let years_all = {
                    year: year,
                    types: row_types
                }
                result_charts.push(years_all);
            })

            let items_chart = [];

            result_charts.forEach((item, index) => {
    
                let type = {};
                item.types.forEach((info) => {
                    type[info.visit_type] = info[amount_type]
                })
    
                let result = {
                    year: item.year,
                    ...type
                }
                items_chart.push(result);
            })
    
            let colors = [];
            colors['จัดการเดินทางผ่านบริษัทนำเที่ยว'] = '#3241a6';
            colors['จัดการเดินทางมาเอง'] = '#578e47';
    
            // // attached colors 
            items_chart.push(colors);
            // end process set data format to Stackbar chart

            state.spending_average_income = items_chart;
        }
        
        // process set data format to Table
        let result_tables = [];

        //

                let current_year = parseInt(year_selected);
                let prev_year = current_year - 1;
                let begin_year = parseInt(year_selected) - 2;

                let response_datas = datas.rows.filter((res) => res.year >= begin_year && res.year <= current_year)
                let year_all = years.filter((year) => year  >= begin_year && year <= current_year).sort((a, b) => b - a)

                let countries_filters = [...new Set(response_datas.map((resp) => resp.country))]

                let countries_sets = [];
                let totals_income = 0;
                let totals_average = 0;
                let totals_income_of_group_tour = 0;
                let totals_average_of_group_tour = 0;

                let totals_income_of_none_group_tour = 0;
                let totals_average_of_none_group_tour = 0;


                let sum_incomes_of_country = 0;
                let sum_averages_of_country = 0;

                const year_keys = ['currentYears', 'prevYears', 'beginYears'];

                if (countries.length > 0) {

                    countries.forEach((country) => {

                        //if (countries_filters.includes(country)) {

                            let info_countries = response_datas.length > 0 ? response_datas.filter((res) => res.country) : []
                            let year_datas = {};

                            year_all.forEach((year_data, index) => {

                                let type_datas = [];
                                let type_group_datas = [];
                                let type_none_group_datas = [];

                                //let info_years = info_countries.filter((res) => res.year == year_data);
                                if (spending_types.length > 0) {
                                    spending_types.forEach((spending_type) => {

                                        totals_income = info_countries.filter((resp) => resp.country == country && resp.year == year_data && resp.spending_type == spending_type).map((resp) => resp.incomes).reduce((a, b) => a + b, 0);
                                        totals_average = info_countries.filter((resp) => resp.country == country && resp.year == year_data && resp.spending_type == spending_type).map((resp) => resp.averages).reduce((a, b) => a + b, 0);

                                        // total of visit by GROUP TOUR
                                        totals_income_of_group_tour = info_countries.filter((resp) => resp.country == country && resp.year == year_data && resp.spending_type == spending_type && resp.visit_type == 'จัดการเดินทางผ่านบริษัทนำเที่ยว').map((resp) => resp.incomes).reduce((a, b) => a + b, 0);
                                        totals_average_of_group_tour = info_countries.filter((resp) => resp.country == country && resp.year == year_data && resp.spending_type == spending_type && resp.visit_type == 'จัดการเดินทางผ่านบริษัทนำเที่ยว').map((resp) => resp.averages).reduce((a, b) => a + b, 0);

                                        let group_tour_info = {
                                            spending_type: spending_type,
                                            incomes: totals_income_of_group_tour,
                                            averages: totals_average_of_group_tour
                                        }
                                        type_group_datas.push(group_tour_info);

                                        // total of visit by NON GROUP TOUR
                                        totals_income_of_none_group_tour = info_countries.filter((resp) => resp.country == country && resp.year == year_data && resp.spending_type == spending_type && resp.visit_type == 'จัดการเดินทางมาเอง').map((resp) => resp.incomes).reduce((a, b) => a + b, 0);
                                        totals_average_of_none_group_tour = info_countries.filter((resp) => resp.country == country && resp.year == year_data && resp.spending_type == spending_type && resp.visit_type == 'จัดการเดินทางมาเอง').map((resp) => resp.averages).reduce((a, b) => a + b, 0);

                                        let none_group_tour_info = {
                                            spending_type: spending_type,
                                            incomes: totals_income_of_none_group_tour,
                                            averages: totals_average_of_none_group_tour
                                        }
                                        type_none_group_datas.push(none_group_tour_info);

                                        //console.log(`${country}: ${spending_type} incomes group tour `,totals_income_of_group_tour);
                                        //if (year_data != begin_year) {
                                            sum_incomes_of_country += totals_income;
                                            sum_averages_of_country += totals_average;
                                        //}
                                        let all_info = {
                                            spending_type: spending_type,
                                            incomes: totals_income,
                                            averages: totals_average
                                        }
                                        type_datas.push(all_info);
                                    })

                                }

                                let year_info = {
                                    year: year_data,
                                    type_of_data: type_datas,
                                    group_tour: type_group_datas,
                                    none_group_tour: type_none_group_datas
                                }
                                year_datas[year_keys[index]] = year_info;
                            })

                            let country_format = {
                                country: country,
                                totals: {
                                    total_incomes: sum_incomes_of_country,
                                    total_averages: sum_averages_of_country
                                },
                                ...year_datas
                            }
                            countries_sets.push(country_format);
                        //}
                    });

                }


                state.spending_average_income_table_type = visit_type_selected == null ? 'standard_summary' : visit_type_selected;
              
                let results_table = {
                    rows: countries_sets,
                    years: [current_year, prev_year],
                    count: countries_sets.length
                }
                state.spending_average_income_table = results_table
            
        //}
       
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}